import { useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Check, Ban } from "lucide-react";

export default function StoresModeration({ region, onChange }) {
  const [stores, setStores] = useState([]);
  const load = async () => {
    try { const { data } = await api.get("/admin/stores", { params: { region } }); setStores(data); }
    catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, [region]);
  const act = async (id, action) => {
    try { await api.post(`/admin/stores/${id}/${action}`); toast.success(action === "approve" ? "Store approved" : "Store blocked — its adverts are hidden"); load(); onChange?.(); }
    catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  return (
    <Card data-testid="op-stores-card">
      <CardHeader>
        <CardTitle className="font-display text-xl">Stores in {region}</CardTitle>
        <CardDescription>Approve new stores so they can post. Blocking hides all of a store&apos;s adverts.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        {stores.length === 0 && <div className="text-sm text-slate-500" data-testid="op-stores-empty">No stores in {region} yet.</div>}
        {stores.map((s) => (
          <div key={s.id} className="flex flex-col sm:flex-row sm:items-center gap-2 border border-slate-200 rounded-xl p-3" data-testid={`op-store-${s.id}`}>
            <div className="flex-1 min-w-0">
              <div className="font-semibold flex items-center gap-2 flex-wrap">{s.store_name}
                {s.approved ? <Badge className="bg-emerald-700 hover:bg-emerald-700">Approved</Badge> : s.blocked ? <Badge variant="outline" className="border-red-300 text-red-700">Blocked</Badge> : <Badge variant="outline" className="border-amber-400 text-amber-800">Pending</Badge>}
                {s.plan_status && s.plan_status !== "none" && <Badge variant="outline" className="text-[10px]">Plan: {s.plan_status}</Badge>}
              </div>
              <div className="text-xs text-slate-500 truncate">{s.email}{s.phone && ` · ${s.phone}`}{s.address && ` · ${s.address}`}</div>
            </div>
            {s.approved
              ? <Button size="sm" variant="outline" className="border-red-200 text-red-700" onClick={() => act(s.id, "reject")} data-testid={`op-block-${s.id}`}><Ban className="w-4 h-4 mr-1" />Block</Button>
              : <Button size="sm" className="bg-emerald-700 hover:bg-emerald-800" onClick={() => act(s.id, "approve")} data-testid={`op-approve-${s.id}`}><Check className="w-4 h-4 mr-1" />Approve</Button>}
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
